import React from 'react';
import { ACCOUNT_PLAN_TYPE_OPTIONS, ACCOUNT_PLAN_TYPE_COLORS } from '../../../core/constants/financial';

const AccountPlanSummary = ({ accounts, filterType, setFilterType }) => {
  const countByType = (type) => accounts.filter((a) => a.type === type).length;

  return (
    <div className="fd-modal-summary" style={{ gridTemplateColumns: 'repeat(5, 1fr)' }}>
      {ACCOUNT_PLAN_TYPE_OPTIONS.map((opt) => (
        <div
          key={opt.value}
          className="fd-modal-summary-item"
          style={{
            cursor: 'pointer',
            background: filterType === opt.value ? 'rgba(255,255,255,0.06)' : 'transparent',
          }}
          onClick={() => setFilterType(filterType === opt.value ? '' : opt.value)}
          aria-label={`Filtrar por ${opt.label}`}
          role="button"
        >
          <span className="fd-modal-summary-label" style={{ color: ACCOUNT_PLAN_TYPE_COLORS[opt.value]?.color }}>
            {opt.label}
          </span>
          <span className="fd-modal-summary-value" style={{ color: ACCOUNT_PLAN_TYPE_COLORS[opt.value]?.color }}>
            {countByType(opt.value)}
          </span>
          <span style={{ fontSize: 9, color: '#999' }}>contas</span>
        </div>
      ))}
      <div
        className="fd-modal-summary-item fd-modal-summary-item--last"
        style={{
          cursor: 'pointer',
          background: !filterType ? 'rgba(255,255,255,0.06)' : 'transparent',
        }}
        onClick={() => setFilterType('')}
        aria-label="Mostrar todas as contas"
        role="button"
      >
        <span className="fd-modal-summary-label">Total Geral</span>
        <span className="fd-modal-summary-value">{accounts.length}</span>
        <span style={{ fontSize: 9, color: '#999' }}>contas cadastradas</span>
      </div>
    </div>
  );
};

export default AccountPlanSummary;
